import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'GgmsToggle',
  props: {
    modelValue: {
        type: Boolean,
        required: true,
    },
    truthLabel: {
        type: String,
        default: "Yes",
    },
    falseLabel: {
        type: String,
        default: "No",
    },
},
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {

const props = __props
const emit = __emit

function toggle() {
    emit("update:modelValue", !props.modelValue)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "bg-gray-100 flex rounded-md text-sm cursor-pointer items-center",
    onClick: toggle
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["px-5 m-0.5 text-sm rounded-md py-2 min-w-[90px] text-center", { 'bg-white shadow-sm border-gray-200 border': __props.modelValue }])
    }, _toDisplayString(__props.truthLabel), 3),
    _createElementVNode("div", {
      class: _normalizeClass(["px-5 m-0.5 text-sm rounded-md py-2 min-w-[90px] text-center", { 'bg-white  shadow-sm border-gray-200 border': !__props.modelValue }])
    }, _toDisplayString(__props.falseLabel), 3)
  ]))
}
}

})